import { encryptData, decryptData, generateHex32 } from "./crypto_helper";
import axios from "../utils/axios";
import { API_URL } from "../constants/config";
import { jwtDecode } from "jwt-decode";

export const getSPAuthTokens = async (SpID,token) => {
  const url                = `${API_URL}ops/api/`;
  const decoded            = jwtDecode(token);
  const accessKey          = `${decoded.account_id}_${decoded.us_uuid}_` + generateHex32();
  const enableKey          = `SPAUTH_${decoded.id}`;
  const spStorageId        = `SPAUTH_${decoded.id}_${SpID}`;
  const spStorageExpiry    = `SPAUTH_${decoded.id}`;
  const isSPStorageEnabled = localStorage.getItem(enableKey);
  const encodedStoredData  = localStorage.getItem(spStorageId);
  const spExpiry           = localStorage.getItem(spStorageExpiry);
  let decodedData          = '';
  
  if (isSPStorageEnabled && encodedStoredData !== '') {
    if (spExpiry && Date.now() > Number(spExpiry)) {
      clearSPAuthTokens();
    } else {
      decodedData = decryptData(encodedStoredData);
    }
  }
  
  if (decodedData !== '') {
    return decodedData;
  } else {
    const res = await axios.post(`${url}generate-auth-token?token=1`, {'access_key': accessKey}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      }
    });
    const newTokenData = res.data.data;
    if (newTokenData) {
      clearSPAuthTokens();
      const expiryTimestamp = Date.now() + 30 * 60 * 1000; // 1 hour in ms
      localStorage.setItem(`SPAUTH_${decoded.id}`, expiryTimestamp);

      const output = Object.entries(newTokenData || {}).reduce((acc, [key, value]) => {
          if (value?.access_token) {
            const data   = value.access_token?.data ?? false;
            const token  = data && data?.token ? data.token : data && data?.api_token ? data.api_token : '';
            const expiry = data && data?.expiry ? data.expiry : null;
            acc[key] = { token, expiry };
          } else if (value.launch_url) {
            acc[key] = { launchUrl: value.launch_url?.lunchUrl ? value.launch_url?.lunchUrl : '' };
          }
          return acc;
      }, {});
      if (output) {
        Object.entries(output).forEach(([key, value]) => {
          const valueData    = value?.token || value?.launchUrl || false;
          const encodedValue = valueData ? encryptData(valueData) : '';
          const storageKey   = `SPAUTH_${decoded.id}_${key}`;
          localStorage.setItem(storageKey, encodedValue);
        });
  
        const tokenOrLaunchUrl = output[SpID].token ? output[SpID].token : output[SpID].launchUrl;
        if (tokenOrLaunchUrl !== null) {
          return tokenOrLaunchUrl;
        }
        return false;
      }
    }
    return false;
  }
}

export const createSPAuthLocalStorage = (id, spAuthTokens) => {
  const output = Object.entries(spAuthTokens || {}).reduce((acc, [key, value]) => {
      if (value?.access_token) {
        const data   = value.access_token?.data ?? false;
        const token  = data && data?.token ? data.token : data && data?.api_token ? data.api_token : '';
        const expiry = data && data?.expiry ? data.expiry : null;
        acc[key] = { token, expiry };
      } else if (value.launch_url) {
        acc[key] = { launchUrl: value.launch_url?.lunchUrl ? value.launch_url?.lunchUrl : '' };
      }
      return acc;
  }, {});

  if (output) {
    Object.entries(output).forEach(([key, value]) => {
      const valueData    = value?.token ? value.token : value?.launchUrl ? value.launchUrl : false;
      const encodedValue = valueData ? encryptData(valueData) : '';
      localStorage.setItem(`SPAUTH_${id}_${key}`, encodedValue);
    });
    return true;
  }
  return false;
}

export const clearSPAuthTokens = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('SPAUTH_')) {
      localStorage.removeItem(key);
    }
  });
};